export default __webpack_public_path__ + "static/media/bg-desktop.e23a1499.svg";